<template>
  <div class="ficha-mapa ficha-localidades">
    <div class="encabezado">Localidades</div>
    <div class="contenedor">
      <div class="col">
        <div class="ficha">
          <div class="ficha-foto">
            <img
              class="foto"
              src="@/assets/fichas-diagnostico/ficha2/1-Localidads.jpg"
              alt=""
            />
            <div class="degradado"></div>
            <div class="cuadro-contraste"></div>
            <p class="pie-foto">Plaza principal de Texcoco</p>
          </div>
          <div class="ficha-titulo">
            <h4>Localidades</h4>
          </div>
          <div class="ficha-cuerpo">
            <div class="contenedor">
              <div class="col">
                <ul class="m-t-0-md">
                  <li>
                    El área de estudio de la población afectada se delimitó a
                    las siguientes delegaciones y municipios de la Ciudad de
                    México y del Estado de México: Venustiano Carranza, Gustavo
                    A. Madero, Ecatepec, Acolman, Tezoyuca, Atenco, Texcoco,
                    Chimalhuacán y Nezahualcóyotl.
                  </li>
                  <li>
                    <b
                      >La población total del área de estudio es de 5,461,026
                      habitantes</b
                    >, distribuidos en 115 localidades, de las cuales 51.30% son
                    rurales y 48.70% urbanas.
                  </li>
                </ul>
              </div>
              <div class="col">
                <img
                  class="vis m-b-1"
                  src="@/assets/fichas-diagnostico/ficha2/Ficha2_Localidades-Dona.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="ficha-separador"></div>

      <div class="col">
        <div class="ficha">
          <div class="ficha-foto">
            <img
              class="foto"
              src="@/assets/fichas-diagnostico/ficha2/2-Localidades.jpg"
              alt=""
            />
            <div class="degradado"></div>
            <div class="cuadro-contraste"></div>
            <p class="pie-foto">Cerro de Huatepec</p>
          </div>
          <div class="ficha-titulo">
            <h4>Localidades indígenas</h4>
          </div>
          <div class="ficha-cuerpo">
            <p>
              Se han identificado
              <b>26 municipios donde existe una cultura agrícola</b>
              con alto valor ambiental e interés socioecológico estratégico.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Localidades",
};
</script>
